import { Alert } from '@material-tailwind/react';
import React from 'react';
import { InfoIcon } from 'lucide-react';

const Settings = () => {
    return (
        <div className='p-4'>
            <Alert color='blue' icon={<InfoIcon />}>
                Coming Soon
            </Alert>
        </div>
    );
};

export default Settings;